import { Link, Outlet } from "react-router-dom";
import Logo from "../../assets/pato.png";
import "./navigation.css";
import { useEffect } from "react";
import { useLanguage } from "../../i18n/LanguageContext";

export const Navigation = () => {
  const { locale, setLocale, t } = useLanguage();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <nav className="navigation">
          <div className="logo">
            <Link to="/">
              <img src={Logo} alt="pato" />
            </Link>
          </div>
          <div className="navigation__actions">
            <div className="lang-switch" aria-label="language switch">
              <button
                className={locale === "es_MX" ? "active" : ""}
                onClick={() => setLocale("es_MX")}
                type="button"
              >
                ES
              </button>
              <button
                className={locale === "en_US" ? "active" : ""}
                onClick={() => setLocale("en_US")}
                type="button"
              >
                EN
              </button>
            </div>
            <a className="contact-link" href="mailto:jeancarlosayala57@gmail.com">
              {t("nav.contact")}
            </a>
          </div>
      </nav>

      <Outlet />
    </>
  );
};
